<template>
<div v-for="cartitem in calcartdatas" :key="cartitem.product_id" class="flex w-screen justify-center grid grid-cols-12 border-gray-200 last:border-0">

    <div class="w-full text-center text-xs text-gray-500 leading-tight col-span-3 sm:col-span-3"> 
        <img :alt="cartitem.product_name" :style="{margin: '0 auto', maxHeight: '70px', width:'60px'}"  :src=cartitem.product_img />
    </div>

    <div class="w-full col-span-3 sm:col-span-3">
        <div class="flex flex-col w-full">
                <h5 class="mb-1">{{ cartitem.product_name }}</h5>
                <p class="mb-1">{{ cartitem.product_price }}</p>
            </div>
    </div>

    <div class="w-full col-span-3 sm:col-span-3">
        <div class="flex flex-row">
            <div>
                <Button  @click="increasequantity(cartitem)" class="w-6 h-6 items-center justify-center bg-blue-600 text-white rounded-full hover:bg-blue-700 transition">
                    <i class="pi pi-plus" style="font-size: 0.7rem;"></i>
                </Button>
            </div>

            <div className="inline px-2"> Qty: {{cartitem.quantity}} </div>

            <div>
                <Button @click="decreasequantity(cartitem)" :disabled="cartitem.quantity < 1" class="w-6 h-6 items-center justify-center bg-blue-600 text-white rounded-full hover:bg-blue-700 disabled:bg-gray-300 transition">
                    <i class="pi pi-minus" style="font-size: 0.7rem;"></i>
                </Button>
            </div>
        </div>
    </div>

</div>
                            
</template>
<script>
import { useUserCartStore } from '../store/storecart.js';
//import Button from "primevue/button";
//import PlusCircleIcon from '../utils/iconsindex.js';
import 'primeicons/primeicons.css'
export default {
    name: 'AppCartList', 
    components: {
        //Button,
        //PlusCircleIcon,
        //PlusIcon
    },
    data() {
        return {
            cartdatas: [],
        };
    },
    computed: {
        calcartdatas() {
            return useUserCartStore().cartData;
        }
    },
    methods: {
            
        async getcartitem() {
            const cartStore = useUserCartStore();
            this.cartdatas = cartStore.cartData;
            console.log(this.cartdatas.cartData);
        },
        addcart() {
            console.log("addcartquantity");
        },
        increasequantity(cartitem)
        {
            //const cartStore = useUserCartStore();
            console.log('increasequantity(cartitemdata)');
            console.log(cartitem);
            useUserCartStore().increasecartitem(cartitem)
        },
        decreasequantity(cartitem)
        {
            //const cartStore = useUserCartStore();
            console.log('decreaasequantity(cartitemdata)');
            console.log(cartitem);
            useUserCartStore().decreasecartitem(cartitem)
        }
    },
    mounted() {
        this.getcartitem();
        console.log("mounted");
    }
}

</script>
